<template>
<div>
  <OrganizationsContextCard/>
  <v-container v-if="selectedVehicle != null" class="fleet--overview--context__container pa-0">
    <v-row class="pa-0 fleet--overview--context__layout" no-gutters>
      <v-col class="pt-2" cols="12">
        <ContextItemNoEditable
        :iconTooltip="$t('organizations.name')"
        :icon="'fas fa-building'"
        :value="selectedVehicle.organization.name"
        />
        <ContextItemAutoComplete
            :eventName="'click'"
            :iconTooltip="$t('fleet.type')"
            :emptyValue="$t('fleet.add_type')"
            :icon="'fas fa-truck-moving'"
            :value="selectedVehicle.type"
            @autocompleteSave="handleUpdateType"
            :list="vehicleTypeList"
            translate="fleet"
          />
          <ContextItemEditableDimensions
            :customKey="`${selectedVehicle.id}_dimensions`"
            :tooltip="$t('fleet.vehicle_dimensions')"
            :attribute="`${$t('fleet.vehicle_dimensions')}`"
            :dimensions="computedVehicleDimensions"
            :forceIntInput="true"
            @save="handleSetVehicleDimensions"
          />
          <ContextItemEditableWeight
            :customKey="`${selectedVehicle.id}_max_weight`"
            :tooltip="$t('fleet.vehicle_max_weight')"
            :attribute="`${$t('fleet.vehicle_max_weight')}`"
            :label="$t('fleet.weight')"
            :weight="computeVehicleLimitsMaxWeight"
            :forceIntInput="true"
            @save="handleSetVehicleMaxWeight"
          />
          <ContextItemEditableInput
            :iconTooltip="$t('fleet.number_of_vehicles')"
            :icon="'far fa-list-alt'"
            :eventName="'click'"
            :value="selectedVehicle.count"
            emptyValue="0"
            @save-emitted="handleSetCount"
            :savedByEnter="true"
            inputType="number"
          />
        <!-- <ContextItemLabels
          :isEditable="true"
          :iconTooltip="$t('fleet.labels')"
          :labels="computeVehicleLabels"
          :eventName="'click'"
          @handleSaveLabels="handleSetVehicleLabels"
          :algoliaSearchLabels="null"
        /> -->
        <ContextItemLabels
          :isEditable="true"
          :icon="'fas fa-tools'"
          :iconTooltip="$t('fleet.equipment')"
          :labels="computedVehicleEquipment"
          :emptyLabel="`${$t('fleet.add_equipment')}`"
          :eventName="'click'"
          @handleSaveLabels="handleSetEquipment"
          :algoliaSearchLabels="null"
          :allowCustomLabels="false"
          :labelsList="fleetAvailableEquipment"
          translate="equipment"
        />
      </v-col>
      <v-col class="pt-3" cols="12">
        <VehicleDepot :depot="selectedVehicle.depot" :vehicle="selectedVehicle"/>
      </v-col>
      <v-col class="pt-3" cols="12">
        <ContextTitle :title="$t('fleet.pricing')" :enableInfoIcon="false"/>
        <template
          v-for="priceType in vehiclePriceTypeList"
        >
          <div
          :key="priceType"
          >
            <VehiclePricePerKM
            :key="selectedVehicle.id"
            :pricePerKM="selectedVehicle[`${handleVehiclePriceAttributeBasedOnPriceType(priceType)}`]"
            :priceType="priceType"
            :vehicle="selectedVehicle"
            />
          </div>
        </template>
      </v-col>
      <!-- <v-col cols="12" class="pt-3 pb-1">
        <RemoveVehicle :vehicle="selectedVehicle" />
      </v-col> -->
    </v-row>
  </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { vehicleService } from '@/_services'
import ContextItemNoEditable from '@/components/wrld/generic/ContextItemNoEditable.vue'
import ContextItemEditableValue from '@/components/wrld/generic/ContextItemEditableValue.vue'
import ContextItemEditableDimensions from '@/components/wrld/generic/ContextItemEditableDimensions.vue'
import ContextItemEditableWeight from '@/components/wrld/generic/ContextItemEditableWeight.vue'
import ContextItemEditableInput from '@/components/wrld/generic/ContextItemEditableInput.vue'
import ContextItemLabels from '@/components/wrld/generic/ContextItemLabels.vue'
import ContextItemAutoComplete from '@/components/wrld/generic/ContextItemAutoComplete.vue'
import VehiclePricePerKM from '@/components/organizations/fleet/VehiclePricePerKM.vue'
import VehicleDepot from '@/components/organizations/fleet/VehicleDepot.vue'
import ContextTitle from '@/components/drops/detail/ContextTitle'
import OrganizationsContextCard from '@/components/organizations/OrganizationsContextCard'
import RemoveVehicle from '@/components/organizations/fleet/RemoveVehicle'

export default {
  name: 'VehicleClassOverviewContext',
  components: {
    ContextItemNoEditable,
    ContextItemEditableValue,
    ContextItemEditableInput,
    ContextItemLabels,
    ContextItemAutoComplete,
    VehiclePricePerKM,
    VehicleDepot,
    ContextTitle,
    OrganizationsContextCard,
    RemoveVehicle,
    ContextItemEditableDimensions,
    ContextItemEditableWeight
  },
  props: {},
  data () {
    return {
      fleetAvailableEquipment: [],
      vehicleTypeList: [],
      vehiclePriceTypeList: [],
    }
  },
  created () {
    vehicleService.getRestrictionsEnum().then((response) => {
      this.fleetAvailableEquipment = response.map(({ name }) => {
        return name
      })
    })
    vehicleService.getVehicleTypeEnum().then((response) => {
      this.vehicleTypeList = response.map(({ name }) => {
        return {
          text: name,
          type: name,
          id: name
        }
      })
    })
    vehicleService.getVehiclePriceTypeEnum().then((response) => {
      this.vehiclePriceTypeList = response.map(({ name }) => {
        return name
      })
    })
  },
  computed: {
    ...mapGetters([
      'getSelectedResourceSecond'
    ]),
    selectedVehicle () {
      return this.getSelectedResourceSecond
    },
    computeVehicleLimitsMaxWeight: function () {
      return this.$options.filters.roundValueWeight(this.selectedVehicle.vehicleLimits.maxWeight, 0)
    },
    computeVehicleLabels () {
      let vehicleLabels = []
      if (this.selectedVehicle.labels !== null) {
        this.selectedVehicle.labels.forEach((label) => {
          vehicleLabels.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return vehicleLabels
    },
    computedVehicleEquipment () {
      let vehicleEquipment = []
      if (this.selectedVehicle.equipment != null) {
        this.selectedVehicle.equipment.forEach((label) => {
          vehicleEquipment.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return vehicleEquipment
    },
    computedVehicleDimensions () {
      if (this.selectedVehicle != null) {
        return {
          length: this.selectedVehicle.vehicleLimits.length,
          width: this.selectedVehicle.vehicleLimits.width,
          height: this.selectedVehicle.vehicleLimits.height
        }
      }
      return {
        length: 0,
        width: 0,
        height: 0
      }
    }
  },
  methods: {
    ...mapActions({
      setOrganizationVehicleEquipment: 'setOrganizationVehicleEquipment',
      setOrganizationVehicleLabels: 'setOrganizationVehicleLabels',
      setOrganizationVehicleType: 'setOrganizationVehicleType',
      setOrganizationVehicleClassesCount: 'setOrganizationVehicleClassesCount',
      setOrganizationVehicleLimitsDimensions: 'setOrganizationVehicleLimitsDimensions',
      setOrganizationVehicleLimitsMaxWeight: 'setOrganizationVehicleLimitsMaxWeight'
    }),
    handleSetVehicleLabels (labels) {
      const newLabels = labels.map(({ name }) => name)
      let remove = []
      let add = []
      if (this.selectedVehicle.labels != null) {
        this.selectedVehicle.labels.forEach((label) => {
          if (newLabels.indexOf(label) < 0) {
            remove.push(label)
          }
        })
      }
      newLabels.forEach((label) => {
        if (this.selectedVehicle.labels != null) {
          if (this.selectedVehicle.labels.indexOf(label) < 0) {
            add.push(label)
          }
        } else {
          add.push(label)
        }

      })
      const item = { ...this.selectedVehicle, labels: newLabels}
      this.setOrganizationVehicleLabels({ item, vehicleID: this.selectedVehicle.id, remove, add})
    },
    handleSetEquipment (equipment) {
      const newEquipment = equipment.map(({ name }) => name)
      let remove = []
      let add = []
      if (this.selectedVehicle.equipment != null) {
        this.selectedVehicle.equipment.forEach((label) => {
          if (newEquipment.indexOf(label) < 0) {
            remove.push(label)
          }
        })
      }
      newEquipment.forEach((label) => {
        if (this.selectedVehicle.equipment != null) {
          if (this.selectedVehicle.equipment.indexOf(label) < 0) {
            add.push(label)
          }
        } else {
          add.push(label)
        }
      })
      this.setOrganizationVehicleEquipment({
        item: { ...this.selectedVehicle, equipment: newEquipment },
        vehicleID: this.selectedVehicle.id,
        add,
        remove
      })
    },
    handleUpdateType(value) {
      this.setOrganizationVehicleType({
        vehicle: { ...this.selectedVehicle, type: value.type },
        vehicleType: value.type
      })
    },
    handleVehiclePriceAttributeBasedOnPriceType(priceType) {
      switch (priceType) {
        case 'PerEmptyKM':
          return 'pricePerEmptyKM'
        case 'PerFullKM':
          return 'pricePerFullKM'
        case 'Minimal':
          return 'minimalPrice'
      }
    },
    handleSetCount(value) {
      this.setOrganizationVehicleClassesCount({
        vehicle: { ...this.selectedVehicle, count: value },
        vehicleCount: value
      })
    },
    handleSetVehicleDimensions(dimensions) {
      const vehicleLimits = { ...this.selectedVehicle.vehicleLimits, ...dimensions }
      console.log(dimensions)
      this.setOrganizationVehicleLimitsDimensions({
        item: { ...this.selectedVehicle, vehicleLimits },
        vehicleID: this.selectedVehicle.id,
        vehicleLimits
      })
    },
    handleSetVehicleMaxWeight (value) {
      const vehicleLimits = { ...this.selectedVehicle.vehicleLimits, maxWeight: Number(value) * 1000 }
      this.setOrganizationVehicleLimitsMaxWeight({
        item: { ...this.selectedVehicle, vehicleLimits },
        vehicleID: this.selectedVehicle.id,
        vehicleLimits
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
